import { LAB_URL,FORTIFICATION_URL } from "../url";
import HttpService from "./HttpService";
const _axios = HttpService.getAxiosClient();

export const UploadFile = async (body, sampleId) => {
  return _axios
    .post(`${LAB_URL}storage/upload?type=LAB_FILES&id=${sampleId}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((error) => {});
};
export const updateBatchState = async (categoryId, type, batchId, body,sampleTestResult, isExternalTest='') => {
  try {
    return _axios.post(
      `${FORTIFICATION_URL}${categoryId}/${type}/${batchId}/state/lab?sampleTestResult=${sampleTestResult}&isExternalTest=${isExternalTest}`,
      body
    );
  } catch (error) {}
};
export const getDownloadedDocument = async (filename) => {
  return _axios
    .get(`${LAB_URL}storage/get-file?key=${filename}&type=LAB_FILES`, {
      responseType: "blob",
    })

    .catch((error) => {});
};

export const adminCategoryDocDropDown = async () => {
  return _axios.get(`${FORTIFICATION_URL}category/`).catch((error) => {});
};